import { useQuery } from "@tanstack/react-query";

import { withJWTClient } from "./connectClient";

const API_BASE_URL: string =
  (import.meta.env.VITE_HOST_INTEGRATIONS_API_URL as string) || "";
export interface Connector {
  id: string;
  name: string;
  available: boolean;
  features?: Record<string, boolean | string>;
  description?: string;
  icon?: string;
  category?: string;
  install_type?: string;
  config_type?: "internal" | "external";
  external_config_url?: string;
}

export const CONNECTOR_FEATURE_REVIEWS = "reviews";

interface GetConnectorsResponse {
  connectors: Connector[];
}

export async function getConnectors(
  siteId: string,
  features?: string,
): Promise<Connector[]> {
  const params = new URLSearchParams();
  if (features) {
    params.set("features", features);
  }

  const query = params.toString();
  const url = `${API_BASE_URL}/${siteId}/connectors${query ? `?${query}` : ""}`;

  const response = await withJWTClient((client) =>
    client.get<GetConnectorsResponse>(url),
  );

  return response.data.connectors;
}

export const connectorsQueryOptions = (siteId: string, features?: string) => ({
  queryKey: ["connectors", siteId, features],
  queryFn: () => getConnectors(siteId, features),
  staleTime: 5 * 60 * 1000,
});

export function useConnectors(siteId: string, features?: string) {
  return useQuery({
    ...connectorsQueryOptions(siteId, features),
    enabled: !!siteId,
  });
}

export function hasReviewsConnector(connectors: Connector[]): boolean {
  return connectors.some(
    (c) => c.available && !!c.features?.[CONNECTOR_FEATURE_REVIEWS],
  );
}
